module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses
  }, [_c('div', {
    class: _vm.outerClasses
  }, [_c('div', {
    class: _vm.innerClasses
  }, [_c('div', {
    class: _vm.bgClasses,
    style: (_vm.bgStyle)
  })])]), _vm._v(" "), (!_vm.hideInfo) ? _c('span', {
    class: _vm.textClasses
  }, [_vm._t("default", [(_vm.isStatus) ? _c('span', {
    class: _vm.textInnerClasses
  }, [_c('Icon', {
    attrs: {
      "type": _vm.statusIcon
    }
  })], 1) : _c('span', {
    class: _vm.textInnerClasses
  }, [_vm._v("\n                " + _vm._s(_vm.percent) + "%\n            ")])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02481a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/progress/progress.vue
// module id = 588
// module chunks = 1